<script setup lang="ts">
import { useOpenIdAuthenticationStore } from "@/stores/AppStartUp/OpenIdAuthenticationStore";
import { onMounted } from "vue";
import { useAuthUserStore } from "@/stores/AppStartUp/AuthUserStore";
import { useGlobalLoadingStore } from "@/stores/AppStartUp/GlobalLoadingStore";
import { useLanguageStore } from "@/stores/LanguageStore";
import { useDateFormatStore } from "@/stores/DateFormatStore";
import { useRouter } from "vue-router";
import { ROUTE } from "@/router/routeDefinitions";
import { useRoutePermission } from "@/composable/useRoutePermission";

const router = useRouter();

const dateFormatStore = useDateFormatStore();
const openIdAuthenticationStore = useOpenIdAuthenticationStore();
const authUserStore = useAuthUserStore();
const globalLoadingStore = useGlobalLoadingStore();
const languageStore = useLanguageStore();
const routePermission = useRoutePermission();

onMounted(async () => {
    globalLoadingStore.showLoadingScreen();

    try {
        await dateFormatStore.initialize();
        await languageStore.initialize();
        await openIdAuthenticationStore.initialize();
        await authUserStore.initialize();

        await router.isReady();

        await routePermission.initialize();
    } catch (error) {
        console.error("App: Initialization failed", error);
        await router.push({ name: ROUTE.PUBLIC_ERROR_PAGE.NAME });
    } finally {
        globalLoadingStore.hideLoadingScreen();
    }
});
</script>

<template>
    <GlobalLoadingScreen />
    <v-app>
        <router-view />
    </v-app>
</template>
